import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private router: Router) {}

  public isNotExpiredToken(token: string): boolean {
    try {
      const decode: any = jwtDecode(token);
      const exp = decode['exp'];
      return (Date.now() / 1000).toFixed(0) < exp;
    } catch (error) {
      return false;
    }
  }

  public saveUserLoginSuccess(res: any): void {
    localStorage.setItem('type', res.type);
    localStorage.setItem('token', res.token);
  }

  public cleanVariablesStorage(): void {
    localStorage.removeItem('billing-day');
    localStorage.removeItem('billing-value');
    localStorage.removeItem('hourly-sales');
    localStorage.removeItem('informative');
    localStorage.removeItem('payment-methods');
    localStorage.removeItem('ranking-sellers');
    localStorage.removeItem('ranking-filial');
    localStorage.removeItem('top-selling');
    localStorage.removeItem('selling-products');
    localStorage.removeItem('authSeller');

    localStorage.removeItem('tokenV2');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('type');
    localStorage.removeItem('componentsAccess');
    
    localStorage.removeItem('filterInfoBranchs');
    localStorage.removeItem('filterInfoMinDate');
    localStorage.removeItem('filterInfoMaxDate');
    localStorage.removeItem('filterInfoSellers');

    localStorage.removeItem('grupoSelect');
    localStorage.removeItem('filialSelect');
    localStorage.removeItem('breadcrumbStatus');
  }

  public saveComponentsAccess(res: any): void {
    localStorage.removeItem('componentsAccess');
    localStorage.setItem('componentsAccess', res);
  }
  
  public saveTokenV2(res: any): void {
    localStorage.removeItem('tokenV2');
    localStorage.setItem('tokenV2', res);
  }

  public saveToken(token: string): void {
    localStorage.removeItem('token');
    localStorage.setItem('token', token);
  }

  public getToken(): string | null {
    return localStorage.getItem('token');
  }

  public getTokenV2(): string | null {
    return localStorage.getItem('tokenV2');
  }

  public getTokenVerified(): string {
    const token = this.getToken();

    if (!token) {
      this.router.navigate(['/']);
      return '';
    } else {
      return token;
    }
  }

  public saveRefreshToken(token: string): void {
    localStorage.removeItem('refreshToken');
    localStorage.setItem('refreshToken', token);
  }

  public getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }

  public saveTenant(tenant: any): void {
    localStorage.removeItem('tenant');
    localStorage.setItem('tenant', tenant);
  }

  public getTenant(): string | null {
    return localStorage.getItem('tenant');
  }

  public getEmail(): string {
    const token = this.getTokenVerified();

    try {
      const decode: any = jwtDecode(token);

      return decode['email'];
    } catch (error) {
      return 'Unauthorized';
    }
  }

  public signOut(): void {
    this.cleanVariablesStorage();

    this.router.navigate(['/login']);
  }

  public saveUsername(username: any): void {
    localStorage.removeItem('username');
    localStorage.setItem('username', username);
  }

  public getUsername(): string | null {
    return localStorage.getItem('username');
  }
}
